export enum RequestMethod {
    GET = "GET",
    PATCH = "PATCH",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE"
}
